import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Checkbox } from "material-ui"
import strings from "../../../../localization/strings"
import DateRangeSelect from "../../../../components/common/DateRangeSelect"
import moment from "moment"
import { IDate } from "../../../../models"
interface IProps {
    handleExport(startDate: IDate, endDate: IDate): void
    close(): void
}
interface IState {
    chooseDateRange: boolean
    dateRangeIsValid: boolean
    startDate: IDate
    endDate: IDate
}

export default class IntegrationConfirmDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        const endDate = moment().endOf("day").utc(true).format()
        this.state = {
            chooseDateRange: false,
            dateRangeIsValid: true,
            startDate: endDate,
            endDate
        }
        autobind(this)
    }

    handleExport() {
        this.state.chooseDateRange ?
            this.state.dateRangeIsValid &&
            this.props.handleExport(this.state.startDate, this.state.endDate) :
            this.props.handleExport(null, null)
    }

    render() {
        return (
            <div>
                <Dialog
                    title={strings.Confirm_Dialog}
                    actions={[
                        <FlatButton
                            data-intercom-target={"menu-AccountSettings-Integration-Btn-CloseIntegrationConfirmDialog"}
                            label={strings.CANCEL}
                            primary={false}
                            onClick={this.props.close}
                        />,
                        <FlatButton
                            data-intercom-target={"menu-AccountSettings-Integration-Toggle-Btn-Ok"}
                            label={strings.OK}
                            primary={true}
                            keyboardFocused={true}
                            onClick={this.handleExport}
                        />,
                    ]}
                    modal
                    open
                    onRequestClose={this.handleExport}
                >
                    <div>{strings.Are_you_sure_you_want_to_export_to_third_party}</div>
                    <Checkbox
                        data-intercom-target={"menu-AccountSettings-IntegrationConfirmDialog-Checkbox-ChooseDateRange"}
                        label={strings.Choose_Date_Range}
                        style={{ marginTop: 20 }}
                        checked={this.state.chooseDateRange}
                        onCheck={(e, value) => this.setState({ chooseDateRange: value })}
                    />
                    {this.state.chooseDateRange &&
                        <DateRangeSelect
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            handleChange={(startDate, endDate, isValid) => this.setState({ startDate, endDate: moment(endDate).endOf("day").utc(true).format(), dateRangeIsValid: isValid })}
                        />
                    }
                </Dialog>
            </div>
        )
    }
}